import { AfterViewInit, Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';

@Component({
    selector: 'app-cookies-disclaimer',
    templateUrl: './cookies-disclaimer.component.html',
    styleUrls: ['./cookies-disclaimer.component.scss'],
    standalone: false
})
export class CookiesDisclaimerComponent implements OnInit {
  @ViewChild('cookieBanner') cookieBannerRef?: ElementRef<HTMLElement>;
  consentGiven = false;
  activeTab = 'consent'
  private readonly cookieOffsetCssVar = '--cookie-banner-offset';
  private resizeObserver: ResizeObserver | null = null;
  constructor() { }

  ngOnInit(): void {
   const consent = localStorage.getItem('cookiesConsent');
   this.consentGiven = consent ? JSON.parse(consent) : false;
  }

  ngAfterViewInit(): void {
    this.startCookieBannerObserver();
  }

  giveConsent() {
    this.consentGiven = true;
    localStorage.setItem('cookiesConsent', JSON.stringify(this.consentGiven));
    this.stopCookieBannerObserver();
    this.clearCookieBannerOffset();
  }

  ngOnDestroy(): void {
    this.stopCookieBannerObserver();
    this.clearCookieBannerOffset();
  }

  private startCookieBannerObserver(): void {
    if (this.consentGiven) {
      this.clearCookieBannerOffset();
      return;
    }

    setTimeout(() => {
      const banner = this.cookieBannerRef?.nativeElement;
      if (!banner) {
        return;
      }

      this.updateCookieBannerOffset();

      this.resizeObserver = new ResizeObserver(() => {
        this.updateCookieBannerOffset();
      });
      this.resizeObserver.observe(banner);
    });
  }

  private stopCookieBannerObserver(): void {
    if (this.resizeObserver) {
      this.resizeObserver.disconnect();
      this.resizeObserver = null;
    }
  }

  private updateCookieBannerOffset(): void {
    const banner = this.cookieBannerRef?.nativeElement;
    const bannerHeight = banner?.getBoundingClientRect().height || 0;
    document.documentElement.style.setProperty(this.cookieOffsetCssVar, `${Math.ceil(bannerHeight)}px`);
  }

  private clearCookieBannerOffset(): void {
    document.documentElement.style.setProperty(this.cookieOffsetCssVar, '0px');
  }

}
